import { Share2 } from 'lucide-react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';
import { CHANNELS_PATH } from '../pressReleaseTypes';

/*
  What Public Relations configures — one row per surface, each leading to its own page. One row
  today, so the route and the sidebar entry carry its key. A row added owes its key to both in the
  same change, as `anyOf`.
*/
const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'channels',
    label: 'Channels',
    description: 'Where a press release is posted — Facebook, Website, Instagram. Each is a line on every published release’s checklist.',
    icon: Share2,
    to: CHANNELS_PATH,
    permission: 'press-release-channels.read',
  },
];

/**
 * Public Relations → Settings: a **menu of what the suite configures**, not the settings themselves.
 * Each row leads to a full page.
 */
export function PublicRelationsSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Public Relations', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-auto p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          <p className="text-xs text-slate-500">
            The vocabulary Press Release draws on. The press releases themselves are on their own page.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
